import { useEffect, useMemo } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

const CHUNK_ERROR_PATTERN =
  /failed to fetch dynamically imported module|importing a module script failed|chunkloaderror|loading chunk .* failed|error loading dynamically imported module/iu
const RELOAD_GUARD_PREFIX = 'yihang:route-chunk-reload:'
const RELOAD_GUARD_TTL_MS = 60_000

function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`.trim()
  return '页面加载失败'
}

function isChunkLoadError(error: unknown): boolean {
  return CHUNK_ERROR_PATTERN.test(errorMessage(error))
}

export function RouteErrorPage() {
  const error = useRouteError()
  const chunkLoadError = isChunkLoadError(error)
  const guardKey = useMemo(
    () => `${RELOAD_GUARD_PREFIX}${window.location.pathname}${window.location.search}`,
    [],
  )

  useEffect(() => {
    if (!chunkLoadError) return
    const lastReload = Number(window.sessionStorage.getItem(guardKey) ?? '0')
    if (Number.isFinite(lastReload) && Date.now() - lastReload < RELOAD_GUARD_TTL_MS) return
    window.sessionStorage.setItem(guardKey, String(Date.now()))
    window.location.reload()
  }, [chunkLoadError, guardKey])

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background: '#f7f9fc',
        color: '#10213f',
      }}
    >
      <section
        style={{
          width: 'min(520px, 100%)',
          padding: 32,
          border: '1px solid #dbe3ef',
          borderRadius: 8,
          background: '#fff',
          textAlign: 'center',
        }}
      >
        <img src="/brand/yihang-logo.png" alt="鲨鱼ERP" style={{ height: 52, width: 'auto' }} />
        <h1 style={{ margin: '24px 0 8px', fontSize: 24 }}>
          {chunkLoadError ? '系统已更新' : '页面加载失败'}
        </h1>
        <p style={{ margin: '0 0 24px', color: '#66758f', lineHeight: 1.7 }}>
          {chunkLoadError
            ? '正在加载最新版本；如未自动恢复，请点击下方按钮。'
            : errorMessage(error)}
        </p>
        <button
          type="button"
          onClick={() => {
            window.sessionStorage.removeItem(guardKey)
            window.location.reload()
          }}
          style={{
            minWidth: 160,
            minHeight: 44,
            border: 0,
            borderRadius: 8,
            background: '#2468ed',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          刷新页面
        </button>
      </section>
    </main>
  )
}
